import { Button } from "@trussworks/react-uswds";
import { ReactComponent as Print } from "../images/print.svg";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import styled from "styled-components";

const NoHoverButton = styled(Button)`
  &:hover {
    text-decoration: none;
  }
`;

type PrintButtonProps = {
  className?: string;
};

const PrintButton = ({ className }: PrintButtonProps) => {
  const { t } = useTranslation();

  if (isMobile) return <></>;
  return (
    <NoHoverButton
      onClick={
        () => {
          window.print(); 
        }
      }
      type="button"
      unstyled
      style={{color:'#1E6692'}}
      className={`display-flex align-items-center margin-y-1 width-auto nice_font ${
        className || ""
      }`}
    >
      {t("print")}
      <Print className="margin-left-1" />
    </NoHoverButton>
  );
};

export default PrintButton;
